import * as React from "react";
import Component from "../../../../AbstractComponent";
import SalesPurchaseCharge from "../../../Charge/SalesPurchaseCharge";
// import CreditCharge from "../../../Charge/CreditCharge";

import { Title } from "../../NewCoach/NewCoachComponents/Title";
import { Subtitle } from "../../NewCoach/NewCoachComponents/Subtitle";

export class NewChargeStep3 extends Component {
  render() {
    return (
      <div className="coach-content-wrapper">
        {this.props.coachType === "Receivable" &&
        <>
          <Title
            title={this.props.chargeType !== "payment"
              ? this.trans("coach/newcharge-step3/title-type/tobereceived")
              : (this.props.payment?.name 
                  ? (this.trans("coach/newcharge-step3/payment/received-title-counterparty", {
                    amount: this.formatter.formatNumber(this.props.payment?.amountRemaining, this.props.payment?.currency),
                    counterparty: this.props.payment?.name
                  }))
                  : (this.trans("coach/newcharge-step3/payment/received-title", {
                    amount: this.formatter.formatNumber(this.props.payment?.amountRemaining, this.props.payment?.currency)
                  }))
                  )}
          />
          <Subtitle
            subtitle={this.props.chargeType !== "payment" ? this.trans("coach/newcharge-step3/subtitle-type/tobereceived") : this.props?.payment?.transaction?.description || this.props?.payment?.description}
          />
        </>
        }
        {this.props.coachType === "Payable" &&
        <>
          <Title
            title={this.props.chargeType !== "payment" 
              ? this.trans("coach/newcharge-step3/title-type/tobepaid")
              : (this.props.payment?.name
                  ? this.trans("coach/newcharge-step3/payment/paid-title-counterparty", {
                  amount: this.formatter.formatNumber(this.props.payment?.amountRemaining, this.props.payment?.currency),
                  counterparty: this.props.payment?.name
                  })
                  : this.trans("coach/newcharge-step3/payment/paid-title", {
                    amount: this.formatter.formatNumber(this.props.payment?.amountRemaining, this.props.payment?.currency)
                  })
                )}
          />
          <Subtitle
            subtitle={this.props.chargeType !== "payment" ? this.trans("coach/newcharge-step3/subtitle-type/tobepaid") : this.props?.payment?.transaction?.description || this.props?.payment?.description}
          />
        </>
        }
        {this.props.coachType === "registerIncomingInvoice" &&
        <>
          <Title
            title={this.trans("coach/newcharge-step3/title-type/registerincominginvoice")}
          />
          <Subtitle
            subtitle={this.trans("coach/newcharge-step3/subtitle-type/tobepaid")}
          />
        </>
        }
  
        <div>
          {this.props.coachType !== "receivableCreditInvoice" && this.props.coachType !== "payableCreditInvoice" && (
            <div className="fields-inner-wrapper">
              <SalesPurchaseCharge
                {...this.props} 
                ref={this.props.ref}
                dialogPresentation={true}
                coachType={this.props.coachType}
                selectedOwner={this.props.selectedOwner}
                selectedAgency={this.props.selectedAgency}
                charge={this.props.charge}
                setState={this.props.setState}
                state={this.props.state}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}